import {
	CustomerOrderOrOfferSalesCommissionView,
	CustomerOrderOrOfferSalesCommissionViewProps,
} from "src/components/views/erp/sales/salesCommissions/orderAndOfferViews/CustomerOrderOfOfferSalesCommissionView.tsx";
import { CustomerOrderOfferView } from "src/api/generated/erp/db/types/tables/customerOrderOfferView.ts";
import { Permissions } from "src/api/generated/iam/permissions.ts";
import { useHasPermission } from "src/components/views/erp/common/userPermissions.ts";

export interface CustomerOfferSalesCommissionViewProps
	extends Pick<CustomerOrderOrOfferSalesCommissionViewProps, "salesCommissionId" | "salesCommissionViewRefreshRef"> {
	customerOffer: CustomerOrderOfferView;
}

export const CustomerOfferSalesCommissionView = ({
	customerOffer,
	...other
}: CustomerOfferSalesCommissionViewProps) => {
	const hasPermission = useHasPermission();
	return (
		<CustomerOrderOrOfferSalesCommissionView
			{...other}
			sourceType={"CUSTOMER_OFFER"}
			sourceId={customerOffer.customerOrderOfferId}
			editingEnabled={!customerOffer.isClosed}
			hasManageCommissionPermission={hasPermission(Permissions.Sales.CustomerOfferCommissions.MANAGE)}
		/>
	);
};
